"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteTerm = exports.updateTerm = exports.addTerm = void 0;

var _ = require("."); // import app components


var addTerm = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, dispatch, config) {
    var siteID, taxonomyID, id, title, slug, parentID, description, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            siteID = _ref.siteID, taxonomyID = _ref.taxonomyID, id = _ref.id, title = _ref.title, slug = _ref.slug, parentID = _ref.parentID, description = _ref.description;
            _context.next = 3;
            return (0, _.db)('createTerm', {
              siteID: siteID,
              taxonomyID: taxonomyID,
              id: id,
              title: title,
              slug: slug,
              parentID: parentID,
              description: description
            }, dispatch, config);

          case 3:
            result = _context.sent;
            return _context.abrupt("return", result);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function addTerm(_x, _x2, _x3) {
    return _ref4.apply(this, arguments);
  };
}();

exports.addTerm = addTerm;

var updateTerm = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2, dispatch, config) {
    var siteID, taxonomyID, id, title, slug, parentID, description, result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            siteID = _ref2.siteID, taxonomyID = _ref2.taxonomyID, id = _ref2.id, title = _ref2.title, slug = _ref2.slug, parentID = _ref2.parentID, description = _ref2.description;
            _context2.next = 3;
            return (0, _.db)('updateTerm', {
              siteID: siteID,
              taxonomyID: taxonomyID,
              id: id,
              title: title,
              slug: slug,
              parentID: parentID,
              description: description
            }, dispatch, config);

          case 3:
            result = _context2.sent;
            return _context2.abrupt("return", result);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function updateTerm(_x4, _x5, _x6) {
    return _ref5.apply(this, arguments);
  };
}();

exports.updateTerm = updateTerm;

var deleteTerm = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3, dispatch, config) {
    var siteID, taxonomyID, id, result;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            siteID = _ref3.siteID, taxonomyID = _ref3.taxonomyID, id = _ref3.id;
            _context3.next = 3;
            return (0, _.db)('deleteTerm', {
              siteID: siteID,
              taxonomyID: taxonomyID,
              id: id
            }, dispatch, config);

          case 3:
            result = _context3.sent;
            return _context3.abrupt("return", result);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function deleteTerm(_x7, _x8, _x9) {
    return _ref6.apply(this, arguments);
  };
}();

exports.deleteTerm = deleteTerm;